export default defineNuxtPlugin(() => {
    if (import.meta.client) {

        // // Prevent default browser behavior for drop (prevents opening file)
        // window.addEventListener('drop', (e) => {
        //     if (e.defaultPrevented) return // Already handled by app
        //     e.preventDefault()

        //     const files = e.dataTransfer?.files
        //     if (files && files.length > 0) {
        //         console.log('Global drop blocked file open. Files:', files.length)
        //     }
        // })

        // // Prevent default browser behavior for dragover (allows drop to happen)
        // window.addEventListener('dragover', (e) => {
        //     e.preventDefault()
        // })


    }
})
